<div class="container mt-5 mb-5">
    <div *ngFor="let exp of experienceList">
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <h4>{{ exp.start_date | expCalcPipe: exp.end_date }} Yrs</h4>
                <h4 class="cmpny-name">{{exp.employer_name}}</h4>
                <p>Website : <a href="{{exp.website}}" target="_blank">{{exp.website}}</a></p>
                <ul class="timeline">
                    <li *ngFor="let role of exp.roles">
                        <div class="row">
                            <div class="col-md-6">
                                <h5>{{role.name}}</h5>
                            </div>
                            <div class="col-md-6 text-right">
                                <h5 class="yrs-exp" *ngIf="!exp.current_emp">{{role.role_start_date | date:'MMM y'}} -
                                    {{role.role_end_date |
                                    date:'MMM y'}}</h5>
                                <h5 class="yrs-exp" *ngIf="exp.current_emp">{{role.role_start_date | date:'MMM y'}} -
                                    Present</h5>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <p *ngFor="let res of role.responsibilities">{{res}}</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>